import { Outlet } from 'react-router-dom';

export default function ProfilePage(): JSX.Element {
  return <Outlet />;
}
